import moment from 'moment';
import { STATES } from 'common/domain/states';

import {
  MANAGER_MAINNAVBAR_STATES,
  HOLIDAY_SUMMARY_VISIBILITY_STATES,
  EMPLOYEE_AFK_VISIBILITY_STATES,
  EVENTS,
  PAGE_ERROR
} from 'common/domain/constants';

import Link from 'components/mainMenu/link';

class VacationsAbsencesRoutingController {

  constructor(
    $scope,
    $translate,
    $location,
    $state,
    $q,
    $window,
    vacationsAbsencesService,
    vacationDelegationService,
    vacationUserDataService,
    ManagerNavigationService,
    toastr,
    inceptionService,
    metricsService
  ) {
    'ngInject';
    this.scope = $scope;
    this.translate = $translate;
    this.location = $location;
    this.state = $state;
    this.q = $q;

    this.vacationUserDataService = vacationUserDataService;
    this.vacationsAbsencesService = vacationsAbsencesService;
    this.vacationDelegationService = vacationDelegationService;
    this.ManagerNavigationService = ManagerNavigationService;
    this.toastr = toastr;
    this.inceptionService = inceptionService;
    this.metricsService = metricsService;

    this.isMobileApp = $window.innerWidth < 1024;
    this.isLoaded = false;
    this.hasDelegated = false;
    this.links = [];

    this.scope.$on(EVENTS.ICON_DELEGATIONS, () => {
      this._initData();
    });
  
    this.scope.$on(EVENTS.REFRESH_EMPLOYEE, (event, data) => {
      this.employee=data;
    });
  }

  $onInit() {
    if (this.isModuleClosed()) {
      return;
    }

    this.vacationsAbsencesService.loadData();

    this.metricsService.init();

    this.scope.$watch(() => this.vacationsAbsencesService.loaded, (newValue) => {
      if (newValue) {
        this.isLoaded = true;
        this.employee = this.vacationUserDataService.getEmployee();
        this.manager = this.vacationsAbsencesService.ManagerDataService._manager;
        this.teamRequestData = this.vacationsAbsencesService.TeamRequestDataService.getData();
        this.userId = this.employee.userId;
        this.employeeHasDelegations = this.employee.hasDelegation();
        this.isManager = this.employee.isManager();
        this._initData();
        let hasElevatedRights = this.employee.hasDelegation() || this.employee.isManager();
        this.ManagerNavigationService.canNavigateToState(hasElevatedRights);
      }
    });
    
    this.setInceptionFlag();
    this.refreshInceptionFlag();
  }

  _initData() {
    this.q.all([this._translate(), this._checkDelegations()]).then(() => {
      this._initLinks();
      this._showToasts();
    });
  }

  _showToasts() {
    if (this.moduleClosed.payrollUpdate) {
      this.toastr.error(this.textToast, this.titleToast);
    }
  }

  _translate() {
    return this.q.all([
      this.translate('VACATIONS_ABSENCES.MAIN.MY_VACATIONS').then((translation) => {
        this.myVacations = translation;
      }),

      this.translate('VACATIONS_ABSENCES.MAIN.TEAM_REQUESTS').then((translation) => {
        this.teamRequests = translation;
      }),

      this.translate('VACATIONS_ABSENCES.MAIN.TEAM_CALENDAR').then((translation) => {
        this.teamCalendarLiteral = translation;
      }),

      this.translate('VACATIONS_ABSENCES.MAIN.SCHEDULE_MOBILE').then(translation => {
        this.scheduleMobileLiteral = translation;
      }),

      this.translate('VACATIONS_ABSENCES.MAIN.DELEGATE_RIGHTS').then((translation) => {
        this.delegations = translation;
      }),

      this.translate('GLOBALS.WARNING_TITLE').then(translation => {
        this.titleToast = translation.$$unwrapTrustedValue();
      }),

      this.translate('GLOBALS.READ_ONLY_WAGE_IN_PROCESS').then(translation => {
        this.textToast = translation.$$unwrapTrustedValue();
      }),
    ]);
  }

  _initLinks() {
    this.links = [];

    let teamRequestsLink = new Link(this.teamRequests, this.teamRequests, STATES.VACATIONS_ABSENCES.TEAM_REQUESTS, '');
    teamRequestsLink.setFromStates([STATES.VACATIONS_ABSENCES.TEAM_REQUESTS]);

    let teamCalendarLink = this._getTeamCalendarLink();

    let delegationLink = new Link(this.delegations, this.delegations, STATES.VACATIONS_ABSENCES.DELEGATE, '');

    if (this.isMobileApp) {
      const myVacationsMobileLink = new Link(this.myVacations, this.myVacations, STATES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE, '');

      myVacationsMobileLink.setAltStates([
        STATES.VACATIONS_ABSENCES.PERIOD_LIST_MOBILE,
        STATES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR_MOBILE
      ]);

      this.links.push(myVacationsMobileLink);
    } else {
      this.links.push(new Link(this.myVacations, this.myVacations, STATES.VACATIONS_ABSENCES.MY_VACATIONS, ''));
    }

    if (this.isDelegatedUser() || this.isManager) {
      this.links.push(teamRequestsLink);
      this.links.push(teamCalendarLink);
    }

    if (this.isDelegatedUser()) return;

    if (this.hasDelegated) {
      delegationLink.setAlertIcon('icon-warning');
    }

    if (this.isManager) {
      this.links.push(delegationLink);
    }

    if (this.isMobileApp) {
      const scheduleMobile = new Link(this.scheduleMobileLiteral, this.scheduleMobileLiteral, STATES.VACATIONS_ABSENCES.SCHEDULE_MOBILE, '');
      this.links.push(scheduleMobile);
    }
  }

  _getTeamCalendarLink() {
    const {TEAM_CALENDAR, TEAM_CALENDAR_MOBILE} = STATES.VACATIONS_ABSENCES;
    const destination = this.isMobileApp ? TEAM_CALENDAR_MOBILE : TEAM_CALENDAR;
    const teamCalendarLink = new Link(this.teamCalendarLiteral, this.teamCalendarLiteral, destination, '');
    teamCalendarLink.setFromStates([TEAM_CALENDAR, TEAM_CALENDAR_MOBILE]);
    return teamCalendarLink;
  }

  isDelegatedUser() {
    return this.employeeHasDelegations && !this.isManager;
  }

  _checkDelegations() {
    const today = moment().format('YYYY-MM-DD');
    return this.vacationDelegationService.getDelegations(this.userId).then((delegations) => {
      this.delegation = this.vacationDelegationService.findDelegationActive(today, delegations);
      this.hasDelegated = Object.keys(this.delegation).length > 0;
    }, (error) => {
      this.delegationsErrorMessage = error.data.message;
      this.hasDelegated = false;
    });
  }

  showHolidaySummary() {
    this.currentState = this.state.current.name;
    return HOLIDAY_SUMMARY_VISIBILITY_STATES.includes(this.currentState);
  }

  refreshInceptionFlag() {
    this.scope.$watch(() => this.state.current.name, () => {
      this.setInceptionFlag();
    });
  }

  setInceptionFlag() {
    this.isInception = this.state.current.name === MANAGER_MAINNAVBAR_STATES.EMPLOYEE_CALENDAR;
  }

  showEmployeeAfk() {
    const STATE_TO_DISPLAY = ['/team-requests', '/team-calendar'];
    return EMPLOYEE_AFK_VISIBILITY_STATES.includes(this.currentState) || STATE_TO_DISPLAY.includes(this.location.path());
  }

  getTeamRequestsClasses() {
    const currentStateIsTeamRequests = this.state.current.name === MANAGER_MAINNAVBAR_STATES.TEAM_REQUESTS;
    const redirectionFromTeamRequests = this.stateParams.from === MANAGER_MAINNAVBAR_STATES.TEAM_REQUESTS;
    return {
      active: currentStateIsTeamRequests || redirectionFromTeamRequests,
      link: true,
    };
  }

  getTeamCalendarClasses() {
    const currentStateIsTeamCalendar = this.state.current.name === MANAGER_MAINNAVBAR_STATES.TEAM_CALENDAR;
    const redirectionFromTeamCalendar = this.stateParams.from === MANAGER_MAINNAVBAR_STATES.TEAM_CALENDAR;
    return {
      active: currentStateIsTeamCalendar || redirectionFromTeamCalendar,
      link: true,
    };
  }

  onSendIncept($event) {
    this.inceptionService.incept($event.employee, $event.from);
  }

  showMenuDesktop() {
    return (this.isManager || this.employeeHasDelegations) && !this.isMobileApp;
  }

  showMenuMobile() {
    return this.isMobileApp && this.links && this.links.length > 0;
  }

  isModuleClosed() {
    if(this.moduleClosed.isVacationsAbsencesClosed && this.moduleClosed.vacationsAbsencesClosedMessage) {
      this.state.go(STATES.ERROR, {stateName: PAGE_ERROR.CLOSED , errorMessage: this.moduleClosed.vacationsAbsencesClosedMessage });
      return true;
    }
    else if(this.moduleClosed.isVacationsAbsencesClosed){
      this.state.go(STATES.ERROR, {stateName: PAGE_ERROR.CLOSED });
      return true;
    }
    return false;
  }

}

export default VacationsAbsencesRoutingController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/vacationsAbsencesRouting/vacationsAbsencesRouting.controller.js